"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GDPRCoOv = void 0;
var GDPRCoOv = /** @class */ (function () {
    function GDPRCoOv(config) {
        this.config = config;
        this.GDPR_COOKE_KEY = 'GDPRCoOv_';
    }
    /**
     * Show iframe and (optionally) save cookie when user accepts the terms within the overlay.
     *
     * @param saveCookie save a cookie to prevent future displaying of the overlay
     */
    GDPRCoOv.prototype.userAccepted = function (saveCookie) {
        if (saveCookie) {
            this.saveCookie();
        }
        this.showIframe();
    };
    /**
     * Initialization that needs to be called after the DOM has been loaded.
     */
    GDPRCoOv.prototype.init = function () {
        if (this.cookieExists()) {
            this.showIframe();
        }
    };
    GDPRCoOv.prototype.showIframe = function () {
        var iframe = document.createElement('iframe');
        // apply default attributes
        iframe.setAttribute('aria-hidden', 'false');
        iframe.setAttribute('allowFullScreen', '');
        // apply settings from config
        iframe.style.border = this.config.iframeSettings.frameBorder;
        iframe.setAttribute('width', this.config.iframeSettings.width);
        iframe.setAttribute('height', this.config.iframeSettings.height);
        iframe.setAttribute('frameBorder', this.config.iframeSettings.frameBorder);
        iframe.setAttribute('src', this.config.iframeSettings.src);
        // show iframe in DOM
        this.getWrapper().appendChild(iframe);
        // remove overlay
        this.removeOverlay();
    };
    GDPRCoOv.prototype.removeOverlay = function () {
        var overlay = document.getElementById(this.config.overlayElemId);
        if (!overlay) {
            throw new Error("Overlay element #" + this.config.overlayElemId + " does not exist.");
        }
        overlay.remove();
    };
    GDPRCoOv.prototype.getWrapper = function () {
        var wrapper = document.getElementById(this.config.wrapperElemId);
        if (!wrapper) {
            throw new Error("Provider wrapper element #" + this.config.wrapperElemId + " does not exist.");
        }
        return wrapper;
    };
    GDPRCoOv.prototype.saveCookie = function () {
        var date = new Date();
        // Get unix milliseconds at current time plus number of days
        date.setTime(date.getTime() + this.config.cookieValidInDays * 86400000); //24 * 60 * 60 * 1000
        window.document.cookie = this.getCookieName() + "=1; expires=" + date.toUTCString() + "; path=/";
    };
    GDPRCoOv.prototype.cookieExists = function () {
        var result = document.cookie.match('(^|;)\\s*' + this.getCookieName() + '\\s*=\\s*([^;]+)');
        return result ? true : false;
    };
    GDPRCoOv.prototype.getCookieName = function () {
        return "" + this.GDPR_COOKE_KEY + this.config.wrapperElemId;
    };
    return GDPRCoOv;
}());
exports.GDPRCoOv = GDPRCoOv;
